import axios from "axios";
import BASEURL from "../Config/global";

export const UpatedScofaFlagInModule = async (config) => {
    try {
        const { data, category_name } = config;
        const url = `/api/misc/scofa-flag-bulk/${category_name}/`;
        const payload = { 'updates': data }
        const response = await axios.patch(BASEURL + url, payload);
        return response;

    } catch (error) {
        console.log(error)
    }
}
